import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import { logger } from 'client/utils/logger/logger';

import './html-video-player.scss';

export function HtmlVideoPlayer({
  src,
  track = null,
  poster = '',
  loop = false,
  autoPlay = false,
  muted = true,
  className = 'w-100 video-js',
  preload = 'auto',
  playsInline = false,
  playback = null,
  onTimeUpdate = noop,
  controls = true,
  ...restProps
}) {
  const videoRef = useRef(null);
  const playPromise = useRef(null);

  function onTimeUpdateHandler() {
    const { duration, currentTime } = videoRef.current;
    onTimeUpdate({ duration, currentTime });
  }

  useEffect(() => {
    if (playback === null) {
      return;
    }

    if (playback) {
      playPromise.current = videoRef.current.play();
      playPromise.current.catch(err => {
        logger.warn(err);
      });
    } else if (playPromise.current) {
      playPromise.current
        .then(() => {
          videoRef.current.pause();
          playPromise.current = null;
        })
        .catch(err => {
          logger.warn(err);
        });
    }
  }, [playback]);

  return (
    <div>
      <video
        crossOrigin=""
        controls={controls}
        ref={videoRef}
        src={src}
        autoPlay={autoPlay}
        loop={loop}
        className={className}
        muted={muted}
        preload={preload}
        playsInline={playsInline}
        onTimeUpdate={onTimeUpdateHandler}
        poster={poster}
        {...restProps}
      >
        <track default kind="captions" srcLang="en" src={track} />
      </video>
    </div>
  );
}

HtmlVideoPlayer.propTypes = {
  src: PropTypes.string.isRequired,
  track: PropTypes.string,
  poster: PropTypes.string,
  loop: PropTypes.bool,
  autoPlay: PropTypes.bool,
  preload: PropTypes.string,
  muted: PropTypes.bool,
  className: PropTypes.string,
  playsInline: PropTypes.bool,
  playback: PropTypes.bool,
  onTimeUpdate: PropTypes.func,
  controls: PropTypes.bool,
};
